import { RegistrationCategoriesContext } from '../components/registration-categories-context';
import { useContext } from 'react';

export function useRegistrationCategories() {
  return useContext(RegistrationCategoriesContext);
}
